// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerAddressAutocompleteWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { MultibrandAddressAutocompleteResponseDto } from '../..';

interface AutocompleteParams {
  partialAddress: string;
}

export const RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Path =
  '/api/web/v1/properties/addresses/autocomplete';

/**
 * Get autocomplete addresses for a partial address
 */
export const RentalManagerAddressAutocompleteWebApiHandler_autocomplete = (
  getParams: AutocompleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AutocompleteParams, never, MultibrandAddressAutocompleteResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
